import React from 'react'
import * as styles from './index.scss'

interface Props {
  title: string | JSX.Element
  description?: string
  loading?: boolean
  odd?: boolean
  style?: React.CSSProperties
}
const Year: React.SFC<Props> = ({
  children,
  title,
  description,
  loading = false,
  odd,
  style,
}) => {
  return (
    <section
      className={styles.year}
      style={{
        backgroundColor: odd && '#fff',
        ...style,
      }}
    >
      <div className={styles.yearInner}>
        <div className={styles.yearHeader}>
          <div className={styles.yearHeaderTitle}>{title}</div>
          <div className={styles.yearHeaderDesc}>{description}</div>
        </div>
        <div className={styles.heroBody}>
          {loading ? (
            <div className={styles.nodata}>努力加载中...</div>
          ) : [].concat(children).length ? (
            children
          ) : (
            <div className={styles.nodata}>暂时什么都没有喔</div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Year
